import * as React from "react";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

//MUI Icons
import FileDownloadIcon from "@mui/icons-material/FileDownloadOutlined";

//Custom Components
import DialogActionButton from "@/ui/Dialog/DialogActionButton";

//Types
import { IDialogActionButtonDetail } from "@/@types/ui/Dialog";

const DialogActionButtonDownload: FunctionComponent<IDialogActionButtonDetail> = (props) => {
  const { t } = useTranslation();

  return (
    <DialogActionButton startIcon={<FileDownloadIcon />} {...props} ariaLabel="download" ariaControls="download">
      {t("buttons.download")}
    </DialogActionButton>
  );
};

export default DialogActionButtonDownload;